export default __webpack_public_path__ + "static/media/single-both-border-none.a0602ab6.svg";